var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 157,
    viewBox: "0 0 243 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2081_13686)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243,
    height: 156.851,
    rx: 8.08511,
    fill: "#141522"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 200.511,
    rx: 8.08511,
    fill: "#141522",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -11.3191,
    cy: -16.1702,
    r: 64.6809,
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.702,
    cy: 200.511,
    r: 64.6809,
    fill: "white",
    fillOpacity: 0.08
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2081_13686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243,
    height: 156.851,
    rx: 8.08511,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/HelpCenter.960dc4ea74fdf23a5b9a5bb998294c93.svg";
export { ForwardRef as ReactComponent };